/** Campaign Naming Validator tab (/marketing "Naming") — full port of erp report/UA/campaign-naming.php. */
export const campaignNaming: Record<string, string> = {
  'naming.dateRange': 'Khoảng thời gian',
  'naming.range.today': 'Hôm nay',
  'naming.range.yesterday': 'Hôm qua',
  'naming.range.last7days': '7 ngày qua',
  'naming.range.last30days': '30 ngày qua',
  'naming.range.thismonth': 'Tháng này',
  'naming.range.lastmonth': 'Tháng trước',
  'naming.network': 'Network',
  'naming.sourceUnavailable': 'Không thể đọc dữ liệu campaign (nguồn tạm thời không khả dụng).',
  'naming.noIssues': 'Không tìm thấy lỗi đặt tên.',
  'naming.issuesFound': 'lỗi đặt tên',
  'naming.campaignName': 'Tên Campaign',
  'naming.extractedCode': 'Mã pCode',
  'naming.issue': 'Vấn đề',
  'naming.spend': 'Chi tiêu',
  'naming.lastSeen': 'Lần cuối',
  'naming.unknownCode': 'pCode không xác định',
}
